<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Transfer Drone</h3>
        <p class="text-aerostar-orange">{{message}}</p>
        <form [formGroup]="transferDroneForm">
            <div class="field-container">
                <mat-form-field>
                    <mat-label>Serial Number</mat-label>
                    <input matInput formControlName="serialNumber" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Model</mat-label>
                    <input matInput formControlName="model" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Manufacture Date</mat-label>
                    <input matInput formControlName="manufactureDate" />
                </mat-form-field>
                @if (notYetTransferred) {
                <br>
                <app-dealer-names-component (messageEvent)="receiveMessage($event)" />
                } @else {
                    <mat-form-field>
                        <mat-label>Transferred to Dealer</mat-label>
                        <input matInput formControlName="transferredToDealerDate" />
                    </mat-form-field><br>
                    <app-customer-names-component (messageEvent)="receiveMessage($event)" />
                }
                <mat-form-field>
                    <mat-label>Transfer Date</mat-label>
                    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" formControlName="transferDate">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </form>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="save()">Save</button>
            <button mat-flat-button (click)="cancel()">Cancel</button>
        </section>
    </section>
</section>
